class SystemError extends Error {
  errorCode: any
  title?: string
  description?: string

  constructor(errorCode: number, message: string, title?: string, description?: string) {
    super()
    this.name = 'SystemError'
    this.errorCode = errorCode
    this.message = message
    this.title = title
    this.description = description
  }
}

export default SystemError
